function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f8fcfc;\n        fill-opacity: 0;\n        fill-rule: evenodd;\n        filter: url(#filter);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
  id: "filter",
  x: 9505.16,
  y: 255.469,
  width: 25.87,
  height: 19.937,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  result: "flood",
  floodColor: "#3d6d75"
}), /*#__PURE__*/React.createElement("feComposite", {
  result: "composite",
  operator: "in",
  in2: "SourceGraphic"
}), /*#__PURE__*/React.createElement("feBlend", {
  result: "blend",
  in2: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M9527.75,275.393h-19.3a3.293,3.293,0,0,1-3.28-3.3V258.77a3.293,3.293,0,0,1,3.28-3.3h19.3a3.293,3.293,0,0,1,3.28,3.3v13.323A3.293,3.293,0,0,1,9527.75,275.393Zm-19.3-18.167a1.543,1.543,0,0,0-1.54,1.544v13.323a1.543,1.543,0,0,0,1.54,1.544h19.3a1.543,1.543,0,0,0,1.54-1.544V258.77a1.543,1.543,0,0,0-1.54-1.544h-19.3Zm9.65,10.9a0.852,0.852,0,0,1-.58-0.221l-10.86-9.69a0.879,0.879,0,0,1,1.17-1.312l10.27,9.171,10.27-9.171a0.879,0.879,0,0,1,1.17,1.312l-10.86,9.69A0.87,0.87,0,0,1,9518.1,268.126Z",
  transform: "translate(-9505.16 -255.469)"
});

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.87,
    height: 19.937,
    viewBox: "0 0 25.87 19.937",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.afcb99a2.svg";
export { ForwardRef as ReactComponent };